import { render, staticRenderFns } from "./CreatorRequestDispute.vue?vue&type=template&id=85edf6e2&"
import script from "./CreatorRequestDispute.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports